import { create } from "zustand";

export type ViewMode = "grid" | "list";
export type SortCol = "name" | "size" | "modified" | "type";
export type SortDir = "asc" | "desc";

interface NavigationState {
  view: ViewMode;
  selection: Set<string>; // names within the current folder
  selectionActive: boolean;
  sort: { col: SortCol; dir: SortDir };
  setView: (v: ViewMode) => void;
  toggleSelection: (name: string) => void;
  setSelection: (names: string[]) => void;
  activateSelection: (name: string) => void;
  clearSelection: () => void;
  single: () => string | undefined;
  setSort: (s: { col: SortCol; dir: SortDir }) => void;
}

export const useNavigation = create<NavigationState>((set, get) => ({
  view: "grid",
  selection: new Set(),
  selectionActive: false,
  sort: { col: "name", dir: "asc" },
  setView: (view) => set({ view }),
  toggleSelection: (name) =>
    set((state) => {
      const next = new Set(state.selection);
      if (next.has(name)) next.delete(name);
      else next.add(name);
      return {
        selection: next,
        selectionActive: state.selectionActive || next.size > 0,
      };
    }),
  setSelection: (names) =>
    set({
      selection: new Set(names),
      selectionActive: names.length > 0,
    }),
  activateSelection: (name) =>
    set({ selection: new Set([name]), selectionActive: true }),
  clearSelection: () => set({ selection: new Set(), selectionActive: false }),
  single: () => {
    const sel = get().selection;
    return sel.size === 1 ? [...sel][0] : undefined;
  },
  setSort: (sort) => set({ sort }),
}));
